<template>
  <v-select
    id="axis-select"
    v-model="filter.eixoId"
    item-text="nome"
    item-name="eixoId"
    item-value="eixoId"
    :items="axis"
    label="Grupo de Solução"
    placeholder="Grupo de Solução"
    clearable
  >
    <template slot="no-data">
      Nenhum Grupo de Solução retornado
    </template>
  </v-select>
</template>

<script>
import { axisAPI } from '@/modules/axis'

export default {
  name: 'AppAxisCombobox',
  props: [
    'filter'
  ],
  mounted () {
    this.loadAxis()
  },
  methods: {
    loadAxis () {
      axisAPI.list()
        .then(resp => {
          this.axis = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      axis: []
    }
  }
}
</script>
